import { render, staticRenderFns } from "./TechnicalViews.vue?vue&type=template&id=c8ccbf70&"
import script from "./TechnicalViews.vue?vue&type=script&lang=js&"
export * from "./TechnicalViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports